<template>
  <FullCalendar ref="fullCalendar" :options="calendarOptions" />
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import '@fullcalendar/core/locales/de';
import rrulePlugin from '@fullcalendar/rrule';
import {RRule, RRuleSet, rrulestr} from 'rrule';

export default {
  props: ['setting', 'bookedSlots'],

  components: {
    FullCalendar,
  },

  /**
   * The component's data.
   */
  data () {
    return {
      calendarOptions: {
        plugins: [
          timeGridPlugin,
          rrulePlugin,
          interactionPlugin,
        ],
        initialView: 'timeGridWeek',
        slotDuration: '01:00:00',
        events: [],
        eventClick: this.handleEventClick,
        contentHeight: 1000,
        selectable: true,
        allDaySlot: false,
        locale: App.locale,
        slotMinTime: '08:00',
        slotMaxTime: '20:00',
        slotLabelInterval: '0',
        firstDay: 1,
        initialDate: moment().format('YYYY-MM-DD'),
        // defaultDate: moment().format("YYYY-MM-DD"),
        // slotLabelFormat: {
        //     hour: 'numeric',
        //     omitZeroMinute: true,
        //     meridiem: 'short'
        // },
        expandRows: true,
        height: '710px',
        // eventTimeFormat: {
        //     hour: '2-digit',
        //     meridiem: true
        // },
        displayEventEnd: false,
        displayEventTime: false,
      }
    };
  },

  computed: {
    minDate () {
      return this.setting.available_from ? this.setting.available_from : '';
    },

    maxDate () {
      return this.setting.available_to ? this.setting.available_to : '';
    },

    weekdays () {
      return JSON.parse(this.setting.weekdays);
    },

    startDate () {
      let date = moment().add(this.setting.min_booking_notice, 'days');
      let day = date.day();

      if (day === 6) {
        date.add(2, 'days');
      }

      if (day === 0) {
        date.add(1, 'days');
      }

      return date.format('YYYY-MM-DD');
    }
  },

  mounted () {
    this.initCalendar();

    this.$refs.fullCalendar.getApi().gotoDate(this.startDate);
  },

  methods: {
    initCalendar () {
      let self = this;

      let maxTime = '00:00';
      let minTime = '23:00';

      for (const [key, value] of Object.entries(this.weekdays)) {
        if (maxTime < value.end) {
          maxTime = value.end;
        }

        if (minTime > value.start) {
          minTime = value.start;
        }
      }

      this.calendarOptions.slotMinTime = minTime;
      this.calendarOptions.slotMaxTime = maxTime;
      this.calendarOptions.events = [];

      for (const [key, value] of Object.entries(self.weekdays)) {
        let availableSlotsRule = new RRuleSet();
        let breakHoursRange = _.range(self.setting.break_start.substr(0, 2), self.setting.break_end.substr(0, 2));
        let byHourRange = _.range(value.start.substr(0, 2), value.end.substr(0, 2)).filter(hour => !breakHoursRange.includes(hour));

        let weekday = key.substr(4);
        let rruleOptions = {
          freq: RRule.HOURLY,
          byweekday: weekday,
          byhour: byHourRange,
        };

        let minBookingNoticeDate = moment().add(self.setting.min_booking_notice, 'days').format('YYYY-MM-DD');
        if (self.setting.available_to && self.setting.available_from) {
          rruleOptions.until = new Date(self.maxDate + 'T00:00:00');

          if (moment(self.minDate).isBefore(minBookingNoticeDate)) {
            rruleOptions.dtstart = new Date(minBookingNoticeDate + 'T00:00:00');
          } else {
            rruleOptions.dtstart = new Date(moment(self.minDate).add(self.setting.min_booking_notice, 'days').format('YYYY-MM-DD') + 'T00:00:00');
          }
        } else {
          rruleOptions.dtstart = new Date(minBookingNoticeDate + 'T00:00:00');
        }

        availableSlotsRule.rrule(new RRule(rruleOptions));

        let rRuleString = availableSlotsRule.toString();

        self.bookedSlots.forEach(bookedSlot => {
          let bookedSlotDate = moment(bookedSlot.speaking_appointment_at);

          //We distract 1 because moment.js weekdays are from 1-7, and rrule weekdays are from 0-6.
          if ((bookedSlotDate.isoWeekday() - 1) === parseInt(weekday) && value.slots <= bookedSlot.total) {
            rRuleString += '\nEXDATE:' + bookedSlotDate.format('YYYYMMDDTHHmmss') + 'Z';
          }
        });

        self.calendarOptions.events.push({
          title: 'Wählen',
          duration: '01:00',
          color: 'white',
          borderColor: '#6c757d', // #ddd
          textColor: '#ddd', // #ddd
          rrule: rRuleString
        });
      }
    },

    handleEventClick (info) {
      $('.fc-timegrid-event').removeClass('selected');
      $(info.el).addClass('selected');

      this.$parent.$emit('selectDate', info.event.start);
    },
  },
};
</script>

<style>
.fc-timegrid-event.selected {
    background-color: #00bf8f !important;
    border-color: #00bf8f !important;
}

.fc-timegrid-event.selected .fc-event-main {
    color: white !important;
}

/*.fc-timegrid-event {*/
/*    border-color: #ddd !important;*/
/*    color: #ddd !important;*/
/*}*/

.fc-timegrid-event-harness {
    margin: 15px !important;
    cursor: pointer !important;
}

/*.fc-theme-standard .fc-scrollgrid {*/
/*    border: none !important;*/
/*}*/

/*.fc td, .fc th {*/
/*    border-style: none !important;*/
/*}*/
</style>
